import type {
  EventAdminDTO,
  CreateEventInput,
  UpdateEventInput,
  MediaListResponse,
} from "@wedding/shared-types";
import { apiClient } from "./client.js";

export function adminLogin(password: string): Promise<{ ok: boolean }> {
  return apiClient.post("/api/admin/login", { password });
}

export function adminLogout(): Promise<{ ok: boolean }> {
  return apiClient.post("/api/admin/logout");
}

export function getAdminConfig(): Promise<{ publicUrl: string }> {
  return apiClient.get("/api/admin/config");
}

export function listAdminEvents(): Promise<{ items: EventAdminDTO[] }> {
  return apiClient.get("/api/admin/events");
}

export function getAdminEvent(id: string): Promise<EventAdminDTO> {
  return apiClient.get(`/api/admin/events/${encodeURIComponent(id)}`);
}

export function createAdminEvent(input: CreateEventInput): Promise<EventAdminDTO> {
  return apiClient.post("/api/admin/events", input);
}

export function updateAdminEvent(id: string, patch: UpdateEventInput): Promise<EventAdminDTO> {
  return apiClient.patch(`/api/admin/events/${encodeURIComponent(id)}`, patch);
}

export function deleteAdminEvent(
  id: string,
): Promise<{ deleted: boolean; mediaCount: number; fileErrors?: string[] }> {
  return apiClient.delete(`/api/admin/events/${encodeURIComponent(id)}`);
}

export function deleteAdminMedia(
  id: string,
): Promise<{ deleted: boolean; errors?: string[] }> {
  return apiClient.delete(`/api/admin/media/${encodeURIComponent(id)}`);
}

export function listAdminEventMedia(
  eventId: string,
  params: { cursor?: string | null; limit?: number } = {},
): Promise<MediaListResponse> {
  const qs = new URLSearchParams();
  if (params.cursor) qs.set("cursor", params.cursor);
  if (params.limit) qs.set("limit", String(params.limit));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiClient.get(`/api/admin/events/${encodeURIComponent(eventId)}/media${suffix}`);
}

export function adminThumbnailUrl(mediaId: string): string {
  return `/api/admin/media/${encodeURIComponent(mediaId)}/thumbnail`;
}
